// extracted by mini-css-extract-plugin
module.exports = {"Resources":"styles_Resources__2YW8s","stopWorkbenchButton":"styles_stopWorkbenchButton__38cUv"};